import { CategoricalPalette, ImperiledSpeciesClass } from './types';

// Canonical 5-class palette for MoBI Protection-Weighted Range-Size Rarity.
// Kept in sync manually with scripts/generate-mobi-data.py, which paints the
// on-map raster PNGs using the same colors so the left-panel bar chart acts
// as the legend for the overlay.
//
// Palette: plasma colormap stops. Chosen to pop on a dark satellite basemap
// — "Very High" is bright yellow, "Very Low" is deep indigo — and to stay
// visually distinct from the viridis ramp used by the Canopy Height layer.
export const IMPERILED_SPECIES_PALETTE: CategoricalPalette<ImperiledSpeciesClass> = {
  colors: {
    very_low:  '#0D0887',
    low:       '#7E03A8',
    moderate:  '#CC4778',
    high:      '#F89441',
    very_high: '#F0F921',
  },
  labels: {
    very_low:  'Very Low',
    low:       'Low',
    moderate:  'Moderate',
    high:      'High',
    very_high: 'Very High',
  },
  order: ['very_low', 'low', 'moderate', 'high', 'very_high'],
};
